export default {"src":"/_next/static/media/video-file.17b65f7d.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};